import { pathWithQueryParams } from 'lib/router/router.util';

export function getClassActivitiesExitUrl(
  pathname: string,
  search: string
): string {
  const searchParams = new URLSearchParams(search);
  const assignmentId = searchParams.get('assignmentId');
  const classId = searchParams.get('classId');
  const activitiesIndex = pathname.indexOf('/activities');
  let basePath = pathname;
  if (activitiesIndex !== -1) {
    basePath = pathname.substring(0, activitiesIndex);
  }

  return pathWithQueryParams(basePath, {
    assignmentId: assignmentId ?? undefined,
    classId: classId ?? undefined,
  });
}
